import { useState } from 'react';
import { faqData } from '@/mocks/categories';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-3 py-1 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-3">
              Frequently Asked
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-900 mb-4">
              Basetao Spreadsheet FAQ
            </h2>
            <p className="text-sm text-foreground-600">
              Quick answers to the most common questions about using spreadsheets with Basetao
            </p>
          </div>

          <div className="space-y-3">
            {faqData.map((item, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => setOpenIndex(openIndex === index ? null : index)}
                  className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-accent-50/30 transition-colors cursor-pointer"
                >
                  <span className="text-sm font-medium text-foreground-900 pr-4">
                    {item.question}
                  </span>
                  <div className={`w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0 transition-colors ${openIndex === index ? 'bg-accent-100 text-accent-600' : 'bg-background-200 text-foreground-500'}`}>
                    <i className={`text-xs transition-transform duration-200 ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: faqData.map((item) => ({
                  '@type': 'Question',
                  name: item.question,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: item.answer,
                  },
                })),
              }),
            }}
          />
        </div>
      </div>
    </section>
  );
}